import _ from 'underscore';
import { FetchPolicy } from '@bingads-webui-react/overreact';
import { getDefaultHeaderObj } from '@bingads-webui/overreact-bingads';

export const networkPolicy = FetchPolicy.NetworkOnly;

export function urlDecorator(fn) {
  function decorator(params, originValue) {
    // TODO: Add decoration
    return originValue;
  }

  return params => decorator(params, fn(params));
}

export function headerDecorator(fn) {
  function decorator() {
    return getDefaultHeaderObj();
  }

  return params => decorator(params, fn(params));
}

export function payloadDecorator(fn) {
  function decorator(params, originValue) {
    // TODO: Add decoration
    return originValue;
  }

  return params => decorator(params, fn(params));
}

export function keySelectorDecorator(fn) {
  function decorator(obj, originValue) {
    // TODO: Add decoration
    return originValue;
  }

  return obj => decorator(obj, fn(obj));
}

export function processorDecorator(fn) {
  function decorator(response, request) {
    const entity = _.omit(request.data, 'OfflineAdIdentities');
    return _.extend(entity, { Id: response.value });
  }

  return (response, request) => decorator(response, request, fn(response, request));
}

function createSideEffectFn(response, request, spec, {
  tryDeleteItemsInCacheStore,
}) {
  const { data } = request;
  // this means we are creating a text ads using a suggestion in UP
  // so we delete this suggestion ad in cache
  if (data['@odata.type'] === '#Model.SearchAd' && data.AdSource && data.AdSource.AdRecommendationGuid) {
    tryDeleteItemsInCacheStore({
      keysToDelete: [data.AdSource.AdRecommendationGuid],
      schemaName: 'get_suggested_ads',
      itemKeySelector: item => item.Id,
    });
  }

  if (data['@odata.type'] === '#Model.ImageAd' && data.AdSource && data.AdSource.TemplateAdId) {
    tryDeleteItemsInCacheStore({
      keysToDelete: [data.AdSource.TemplateAdId],
      schemaName: 'get_suggested_ads',
      itemKeySelector: item => item.Id,
    });
  }
}

export const sideEffects = {
  fetch: null,
  refetch: null,
  mutation: null,
  pagination: null,
  add: createSideEffectFn,
  destroy: null,
};
